import { type PageProps } from "gatsby";
import { type FC } from "react";
import { LoggedOutBar } from "../../components/AppBar/Bars";
import GuidepostSimplified from "../../components/Rozcestnik/GuidepostSimplified";
import { Seo } from "../../components/SEO";
import { withRedirectWhenLoggedIn } from "../../highOrderComponents/withRedirectWhenLoggedIn";

export const AppBar: FC = () => <LoggedOutBar />;

const RegistrationPage: FC<PageProps> = (pageProps) => {
    return <GuidepostSimplified pageProps={pageProps} />;
};

export default withRedirectWhenLoggedIn(RegistrationPage);

export const Head: FC = () => (
    <Seo description="Nejrychlejší registrace je přes Vaši banku. Automaticky předvyplní údaje." title="Registrace" />
);
